
export interface CreateChatThreadRequest {
  /** @nullable */
  isGroupThread?: boolean | null;
  participantIds: string[];
}
